import React from "react";
import { Box, Grid } from "@mui/material";
import { AircraftInfoForm } from "../../components/documents/upload/aircraft-info-form";
import { FileUploadArea } from "../../components/documents/upload/file-upload-area";
import { FileList } from "../../components/documents/upload/file-list";
import { useFileUpload } from "../../hooks/useFileUpload";
import { useWarehouseCategories } from "../../hooks/useWarehouseCategories";

export default function Upload(): React.ReactElement {
  const {
    // State
    files,
    uploading,
    progress,
    isDragging,
    documentScope,
    assemblyType,
    assemblyFolder,
    assemblyCategory,
    tailNumber,
    documentCategory,
    serialNumber,
    aircraftType,
    documentTitle,
    description,

    // Actions
    handleFiles,
    removeFile,
    clearAllFiles,
    uploadFiles,
    handleDrop,
    handleDragOver,
    handleDragLeave,

    // Setters
    setDocumentScope,
    setAssemblyType,
    setAssemblyFolder,
    setAssemblyCategory,
    setTailNumber,
    setDocumentCategory,
    setSerialNumber,
    setAircraftType,
    setDocumentTitle,
    setDescription
  } = useFileUpload();

  // One API call when component type changes. Returns flat list: serial folders
  const { getTopLevelFolders, getChildrenByParentCode } =
    useWarehouseCategories(documentScope === "assembly" ? assemblyType : undefined);

  return (
    <Box sx={{ height: "100%", width: "100%", p: { xs: 1, sm: 2 } }}>
      <Grid container spacing={2} sx={{ 
        flexDirection: { xs: "column", md: "row" },
        height: { md: "100%" },
      }}>
        <Grid size={{ xs: 12, md: 3 }}>
          <AircraftInfoForm
            documentScope={documentScope}
            setDocumentScope={setDocumentScope}
            assemblyType={assemblyType}
            setAssemblyType={setAssemblyType}
            assemblyFolder={assemblyFolder}
            setAssemblyFolder={setAssemblyFolder}
            assemblyFolders={getTopLevelFolders()}
            assemblyCategory={assemblyCategory}
            setAssemblyCategory={setAssemblyCategory}
            assemblyCategories={getChildrenByParentCode(assemblyFolder)}
            tailNumber={tailNumber}
            setTailNumber={setTailNumber}
            documentCategory={documentCategory}
            setDocumentCategory={setDocumentCategory}
            serialNumber={serialNumber}
            setSerialNumber={setSerialNumber}
            aircraftType={aircraftType}
            setAircraftType={setAircraftType}
            documentTitle={documentTitle}
            setDocumentTitle={setDocumentTitle}
            description={description}
            setDescription={setDescription}
            disabled={uploading}
            disabledFields={{}}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <FileUploadArea
            isDragging={isDragging}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onFileSelect={handleFiles}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 3 }}>
          {/* File List */}
          <FileList
            files={files}
            progress={progress}
            uploading={uploading}
            onRemoveFile={removeFile}
            onClearAllFiles={clearAllFiles}
            onUploadFiles={uploadFiles}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
